import React from 'react';

export const InstallationPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-zinc-200">Installation Guide</h1>
      
      <p className="text-zinc-400 mb-8">
        The Haptic Music Player is available as a web app, installable PWA, and Android app. 
        Desktop and iOS versions are coming soon.
      </p>

      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">Web App</h2>
          <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
            <p className="text-zinc-400 mb-4">
              Access the Haptic Music Player directly through your web browser:
            </p>
            <ol className="list-decimal space-y-3 ml-4 text-zinc-400">
              <li>
                Visit <span className="text-yellow-500">https://hapticplayer.app</span>
              </li>
              <li>
                Sign in or create an account to save your preferences
              </li>
              <li>
                Enable haptic feedback when prompted
              </li>
            </ol>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">Progressive Web App (PWA)</h2>
          <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
            <p className="text-zinc-400 mb-4">
              Install the web app on your device for a native app-like experience:
            </p>
            <ol className="list-decimal space-y-3 ml-4 text-zinc-400">
              <li>
                Open the web app in Chrome or Edge
              </li>
              <li>
                Click the install button in your browser's address bar
              </li>
              <li>
                Follow the installation prompts
              </li>
            </ol>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">Android App</h2>
          <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
            <p className="text-zinc-400 mb-4">
              Get the native Android app from the Google Play Store:
            </p>
            <ol className="list-decimal space-y-3 ml-4 text-zinc-400">
              <li>
                Open Google Play Store on your Android device
              </li>
              <li>
                Search for "Haptic Music Player"
              </li>
              <li>
                Click Install and follow the prompts
              </li>
              <li>
                Grant necessary permissions when requested
              </li>
            </ol>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">Coming Soon</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
              <h3 className="text-xl font-medium mb-3 text-zinc-200">Desktop App</h3>
              <p className="text-zinc-400">
                Native Windows and macOS apps are currently in development. Stay tuned for enhanced haptic feedback support and system-level integration.
              </p>
            </div>
            <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
              <h3 className="text-xl font-medium mb-3 text-zinc-200">iOS App</h3>
              <p className="text-zinc-400">
                Our iOS app is in the final stages of development and will be available on the App Store soon.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4 text-zinc-200">System Requirements</h2>
          <div className="bg-zinc-800/50 backdrop-blur p-6 rounded-lg border border-zinc-700/50">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-xl font-medium mb-3 text-zinc-200">Web App / PWA</h3>
                <ul className="list-disc list-inside space-y-2 text-zinc-400">
                  <li>Modern web browser (Chrome, Firefox, Edge, Safari)</li>
                  <li>Stable internet connection</li>
                  <li>Device with haptic feedback capability</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-medium mb-3 text-zinc-200">Android App</h3>
                <ul className="list-disc list-inside space-y-2 text-zinc-400">
                  <li>Android 8.0 or later</li>
                  <li>100MB free storage</li>
                  <li>2GB RAM recommended</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
